import { createContext } from 'react';

import { buildChannelSnapshot, buildEmojiSnapshot, buildProfileSnapshot } from '../lib/entitySnapshotBuilders';

export { buildChannelSnapshot, buildEmojiSnapshot, buildProfileSnapshot } from '../lib/entitySnapshotBuilders';

// Build snapshot maps from arrays of entities, which we make accessible in the shared context
// so each message doesn't need to build its own snapshots from dexie. We tag the result with
// its workspaceId so consumers can tell whether it matches the currently-routed workspace.
export const buildEntitySnapshots = (workspaceId, profiles = [], channels = [], emojis = []) => {
  const profileEntries = profiles.map((profile) => [profile.id, buildProfileSnapshot(profile)]);
  const channelEntries = channels.map((channel) => [channel.id, buildChannelSnapshot(channel)]);

  const emojiEntries = emojis.map((emoji) => {
    const snapshot = buildEmojiSnapshot(emoji);
    return [emoji.id, snapshot];
  });

  const emojiMap = new Map(emojiEntries);

  const emojiByShortcode = new Map();
  emojiEntries.forEach(([, snapshot]) => {
    if (!snapshot?.shortcode || emojiByShortcode.has(snapshot.shortcode)) return;
    emojiByShortcode.set(snapshot.shortcode, snapshot);
  });

  const emojiList = emojiEntries.map(([, snapshot]) => snapshot);

  return {
    workspace_id: workspaceId ? String(workspaceId) : null,
    profile: new Map(profileEntries),
    channel: new Map(channelEntries),
    emoji: emojiMap,
    emojiByShortcode,
    emojiList,
  };
};

// Context to provide entity snapshots throughout the app
export const EntitySnapshotContext = createContext(null);
